module.exports = __webpack_public_path__ + "static/media/emptystate-up.770eb54e.svg";